import type { FaireProductEntity } from "../../entity_types/product";

export const p_wxzz4zvwd5: FaireProductEntity = {
  token: "p_wxzz4zvwd5",
  type: "product",
  name: "Vintage Chenille Ghost Pillow 10 x 10 cottagecore Halloween",
  brandToken: "b_6y2fypfbxf",
  brandName: "A Gnome on the Roam",
  imageUrl:
    "https://cdn.faire.com/fastly/25a3a6bea751a69d4e1d6b52ed3ea02ff483b402c2ff42568f94ac918aafa18e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/459c5bc4089ea3559a8b201ae092c25861e2204a079d363dda4c43bbac530333.jpeg",
    "https://cdn.faire.com/fastly/1cf0b01124c93548a057f5a4e4530b73ad300554213e0331fc2a6e10d5bf068c.jpeg",
    "https://cdn.faire.com/fastly/1a74cc6b8e1743e68bde825acba7f4c2ab447017963c813d10ffb15a2aeddedd.jpeg",
    "https://cdn.faire.com/fastly/b06710ff40622ad06840ab0ab55aad3b267c67216299312709e991fda1154697.jpeg",
    "https://cdn.faire.com/fastly/6b0442c956993b53387930acb7e0d2e535bad4ac2fd87f78532e867e17759839.jpeg",
    "https://cdn.faire.com/fastly/e6cda854c2fcb98fe8ed79f8cc2950ae0f64166cc37a3e6b249b40a8a5da570e.jpeg",
  ],
  priceDollars: 9,
  description:
    "Add a touch of soft, spooky charm to your home with this one-of-a-kind ghost pillow, lovingly handmade from vintage chenille fabric. It's perfect for adding a whimsical Halloween touch or year-round cottagecore vibes.\n\nEach pillow is crafted from rescued vintage textiles, giving new life to beautiful materials and keeping them out of landfills. The chenille pattern adds incredible texture and a nostalgic feel you just can’t replicate with modern fabrics. It measures about 10x10 inches.\n\nDue to the nature of vintage materials, small imperfections or signs of wear may be present and these add to the character and history of each piece.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:34.453Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
